var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691 4466 c-50 -28 -50 -26 -51 -553 l0 -493 28 -30 c15 -16 42 -33 60 -36 32 -6 39 -1 208 167 l174 173 243 -246 c148 -150 259 -254 285 -267 133 -68 302 38 302 189 0 85 -3 89 -328 427 l-184 193 148 157 c82 87 154 164 161 171 42 44 39 97 -9 137 l-30 25 -491 0 c-389 -1 -497 -3 -516 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3395 4458 c-33 -26 -54 -71 -47 -105 3 -15 68 -93 158 -189 85 -90 154 -167 154 -171 0 -4 -109 -117 -243 -252 -138 -140 -250 -262 -260 -283 -62 -134 44 -298 193 -298 78 0 105 21 366 282 l252 251 172 -162 c95 -89 184 -167 198 -172 38 -14 85 -3 113 27 l24 26 3 491 c2 358 -1 499 -9 520 -24 57 -23 57 -557 57 -487 0 -489 0 -517 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3285 1963 c-106 -55 -152 -169 -110 -271 10 -24 102 -123 266 -288 l251 -251 -161 -171 c-175 -188 -187 -210 -157 -274 33 -70 19 -68 560 -68 521 0 525 0 552 51 21 42 21 967 -1 1009 -27 53 -96 87 -141 69 -14 -5 -96 -76 -183 -159 -87 -82 -162 -150 -167 -150 -4 0 -118 109 -253 243 -140 138 -262 250 -283 260 -45 21 -133 21 -173 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1938 c-22 -11 -150 -130 -285 -264 l-245 -243 -70 67 c-248 237 -288 272 -307 272 -11 0 -35 -15 -54 -34 l-34 -34 0 -491 c0 -537 0 -536 57 -560 21 -8 162 -11 521 -9 l492 3 27 28 c22 22 28 37 28 73 0 49 -3 52 -278 313 l-78 74 250 251 c261 262 281 288 281 368 -1 151 -172 256 -305 186z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoom-out-icon.1186baa279b38f8dbd31cd03b8ba0689.svg";
export { ForwardRef as ReactComponent };